import React, { useMemo } from 'react'
import {
  StyledVariable,
  UrgencyHandler,
  ORANGE_GREEN_VARIABLE_NAME,
  type UrgencyEntries,
  type UrgencyVariableKey,
} from '@mc/feature-variables'
import { useTranslation } from '@mc/i18n'
import {
  PROMO_FEATURE_FLAG,
  PROMO_I18N_NAMESPACE,
} from '../../../lib/constants'

export type UrgencyCopyProps = {
  flagName?: string
  fullStop?: boolean
  textKey: UrgencyVariableKey
}

export const UrgencyCopy = ({
  flagName = PROMO_FEATURE_FLAG,
  textKey,
  fullStop = false,
}: UrgencyCopyProps) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)
  const urgencyConfig = useMemo(
    () => ({
      urgencyMessage: {
        variableName: ORANGE_GREEN_VARIABLE_NAME,
        variableKey: textKey,
      },
    }),
    [textKey],
  ) as UrgencyEntries

  return (
    <UrgencyHandler flagName={flagName} config={urgencyConfig}>
      {({ urgencyMessage }) => (
        <>
          <StyledVariable
            text={urgencyMessage}
            defaultCopy={t('common.urgency.soon')}
          />
          {fullStop && '.'}
        </>
      )}
    </UrgencyHandler>
  )
}
